import VueSlickCarousel from 'vue-slick-carousel'
import Modal from '../components/modal'
import Highlights from '../components/highlights'
import FormDownload from '../forms/download'
import BlogNewsletter from '../components/blog-newsletter'
import { Slider, SliderItem } from '../components/slider'
import { NavSlider, NavSliderItem } from '../components/nav-slider'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Service',
  components: {
    Modal,
    Highlights,
    FormDownload,
    BlogNewsletter,
    NavSlider,
    NavSliderItem,
    Slider,
    SliderItem,
    VueSlickCarousel,
  },
  data() {
    return {
      openDownload: false,
      sliderOptions: {
        arrows: false,
        autoplay: true,
        swipe: false,
        autoplaySpeed: 5000,
        slidesToShow: 6,
        speed: 3000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
    }
  },
  methods: {
    generateCaptcha() {
      // hack to trigger form generateCaptcha()
      const openModal = this.$children.find(item => item.show == true)
      openModal.$children[0].generateCaptcha()
    },
  },
}
